import axios from 'axios'
import store from '@/store'
import notification from 'ant-design-vue/es/notification'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 600000000000 // 请求超时时间
})

axios.defaults.headers.post['Content-Type'] = 'application/json';

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    notification.error({
      message: '提示',
      description: error.response.data.msg || error.msg || error.message
    })
  }
  if (error.response.status === 401) {
    localStorage.removeItem('AuthorizationToken');
    window.location.reload()
  }
  return Promise.reject(error)
}
// request interceptor
request.interceptors.request.use(config => {
  const token = localStorage.getItem('AuthorizationToken')
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['AuthorizationToken'] = token
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  if (response.data.code == '10004' || response.data.code == '10001') {
    notification.error({
      message: '提示',
      description: response.data.msg
    })
    localStorage.removeItem('AuthorizationToken');
    window.location.reload()
    return Promise.reject(response);
  } else {
    return response.data;
  }
}, errorHandler)

export default request